let searchFormW = '[js-search-form]';
let bodyOverflowClass = 'o-hidden';


//open search form
$('.menu-item-285').on('click', function(e){
    e.preventDefault();
    //animate
    setTimeout(function(){
        $(searchFormW).find('.bg').toggleClass('down');
    }, 200);
    $(searchFormW).toggleClass('visible');
    //$(this).toggleClass('icon-icon-search').toggleClass('icon-icon-close');
    $('body').toggleClass(bodyOverflowClass);
});

function closeModalSearch(){
    $(searchFormW).find('.bg').removeClass('down');
    setTimeout(function(){
        $(searchFormW).removeClass('visible');
        //$('#page-header .menu-modal .icon-icon-close').toggleClass('icon-icon-search').toggleClass('icon-icon-close');
        $('body').removeClass(bodyOverflowClass);
    }, 200);
}

//close search form
$('[js-close-search-modal]').on('click', function(){
    closeModalSearch();
});


$(window).click(function(event) {
    if ($(event.target).is($('.searchform .black'))) {
        closeModalSearch()
    }
});